<script setup>
import { computed } from 'vue';
import { isSSR } from 'util/ssr';

const props = defineProps({
    linkGreen: {
        type: Boolean,
    },
    link: {
        type: String,
        default: '',
    },
    class: {
        type: String,
        default: '',
    },
    event: {
        type: String,
        default: '',
    },
    client: {
        type: Boolean,
    },
});

const convertedHref = computed(() => {
    try {
        if (isSSR()) {
            // Use Buffer for server-side rendering to ensure links are available for SEO.
            return globalThis.Buffer.from(props.link, 'base64').toString('utf-8');
        }
        // Use atob in the browser, which is more performant.
        return atob(props.link);
    } catch {
        return '#';
    }
});
</script>

<template>
    <span class="m-base64Link">
        <a
            :class="{
                'm-base64Link__a--green': linkGreen,
                [props.class]: props.class,
            }"
            :data-event="event"
            :href="convertedHref"
            class="m-base64Link__a"
        >
            <slot />
        </a></span>
</template>

<style lang="scss">
@use "styles";
</style>
